import { DateTime, Option } from 'effect';
import type { DocumentType } from './schemas/document-type';
import { FREE_PLAN_COUNTRY_CODES } from './free-plan-countries';

// Re-exported, not redeclared: the edge bundle deep-imports the leaf module.
export { FREE_PLAN_COUNTRY_CODES } from './free-plan-countries';

export const MAX_FREE_UPLOADS = 3;

export const FREE_PLAN_REGISTRATION_CUTOFF = DateTime.makeUnsafe(
  '2025-04-04T12:00:00Z',
);

export const isRegisteredBeforeFreePlanCutoff = (
  createdAt: Date | string | null | undefined,
) =>
  Option.fromNullishOr(createdAt).pipe(
    Option.flatMap(DateTime.make),
    Option.exists(DateTime.isLessThan(FREE_PLAN_REGISTRATION_CUTOFF)),
  );

/**
 * Document types a free-plan user may convert, per intake policy. The server
 * enforces these; clients read them to decide what to paywall.
 */
export const FREE_DOCUMENT_TYPES = {
  standard: ['html', 'pdf', 'txt'],
  'email-attachment': ['html', 'pdf'],
  'email-body': ['html', 'txt'],
} as const satisfies Record<string, ReadonlyArray<DocumentType>>;
export type UploadDocumentPolicy = keyof typeof FREE_DOCUMENT_TYPES;

export const isFreeDocumentType = (
  documentType: DocumentType,
  policy: UploadDocumentPolicy = 'standard',
) =>
  (FREE_DOCUMENT_TYPES[policy] as ReadonlyArray<DocumentType>).includes(
    documentType,
  );

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export function isFreePlanCountryCode(countryCode: string | null | undefined) {
  return FREE_PLAN_COUNTRY_CODES.includes(
    countryCode?.toUpperCase() as (typeof FREE_PLAN_COUNTRY_CODES)[number],
  );
}

export function freeUploadWeekStartMs(nowMs: number) {
  const now = new Date(nowMs);
  const daysSinceMonday = (now.getUTCDay() + 6) % 7;
  const mondayAtEightUtc = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate() - daysSinceMonday,
    8,
  );
  return nowMs < mondayAtEightUtc
    ? mondayAtEightUtc - WEEK_MS
    : mondayAtEightUtc;
}

export function nextFreeUploadResetMs(nowMs: number) {
  return freeUploadWeekStartMs(nowMs) + WEEK_MS;
}
